import { AiSmartReplyContactPlanItemStatus } from '../enums/AiSmartReplyContactPlanItemStatus';

export function splitCamelCase(s: string): string {
    // Add a space before all caps
    let result = s.replace(/([A-Z])/g, ' $1');

    // Uppercase the first character and make sure rest is lowercase
    result = result.replace(/(^| )(\w)/g, function (x) {
        return x.toUpperCase();
    });

    // Remove any leading space
    return result.trim();
}

export function aiSmartReplyContactPlanItemStatusToLabel(
    status: AiSmartReplyContactPlanItemStatus,
): string {
    switch (status) {
        case AiSmartReplyContactPlanItemStatus.Unscheduled:
            return 'Waiting for reply';
        case AiSmartReplyContactPlanItemStatus.Failed:
            return 'Failed, retrying';
        default:
            return AiSmartReplyContactPlanItemStatus[status];
    }
}
